<header class="header row">
    <div class="header-content col-12 col-xl-6 no-gutters">
        <div class="input-wrapper">
            <label>
                <input
                    #search
                    class="kk-input"
                    type="text"
                    [title]="'stores.placeholders.searchStore' | translateSafe"
                    [placeholder]="'stores.placeholders.searchStore' | translateSafe"
                    (input)="onSearchChange(search.value)"
                />
                <app-svg-icon iconName="search"></app-svg-icon>
            </label>
        </div>

        <button
            class="kk-btn kk-btn_svg kk-btn_secondary search-btn"
            [ngClass]="{ 'location-active': activeGeo }"
            (click)="activeGeo ? disableLocationService(true) : allowLocationAccess()"
            [disabled]="currentPositionError"
        >
            <app-svg-icon iconName="close to me"></app-svg-icon>
            <span>{{ 'stores.buttons.closeToMe' | translateSafe}}</span>
        </button>
    </div>

    <div class="current-location" *ngIf="currentPositionError || currentPosition" [@easeInOut]>
        {{ currentPositionError ? currentPositionError.code === LocationCodeError.PermissionDenied ?
        ('stores.labels.geoLocationDenied' | translateSafe) : ('stores.labels.positionUnavailable' | translateSafe) : ''
        }} {{ currentPosition ? ('stores.labels.accessingGeolocation' | translateSafe) : '' }}
    </div>
</header>

<section class="content" [ngClass]="{ 'content-pending': (storesService.pending$ | async) === true }">
    <div class="regions">
        <h4>{{ 'stores.headers.regions' | translateSafe }}</h4>

        <div class="regions-content">
            <app-filter-button
                (statusEvent)="onActivateRegion(region)"
                [active]="activeRegions | activeRegion:region"
                class="region-btn"
                *ngFor="let region of storesService.regions$ | async"
            >
                {{ region }}
            </app-filter-button>
        </div>
    </div>

    <div class="wrapper row">
        <div class="col-12 col-lg-6 col-xl-6">
            <div
                class="store-list"
                [ngClass]="{'store-list_open': storeListAnimationState === 'open'}"
                #storeListEl
                [@foldout]="storeListAnimationState"
            >
                <div class="store-list-wrapper" #storeListWrapperEl>
                    <ng-container *ngIf="(storesService.stores$ | async) as stores; else emptyList">
                        <app-store-item
                            class="cxs-store-item"
                            [store]="store"
                            *ngFor="let store of stores | byRegion:activeRegions | slice:0:visibleItems trackBy: trackByStore"
                        ></app-store-item>
                    </ng-container>
                </div>

                <ng-container *ngIf="(storesService.stores$ | async) as stores">
                    <div class="store-list-over" *ngIf="stores.length > defaultVisibleItems">
                        <button
                            (click)="seeMoreStores()"
                            class="store-list_link-more text-semibold"
                            [ngClass]="{
                                'store-list_link-more_open': storeListAnimationState === 'open'
                            }"
                        >
                            <app-svg-icon iconName="chevron_down"></app-svg-icon>
                            <span>
                                {{ storeListAnimationState === 'open' ? ('stores.buttons.seeLess' | translateSafe) :
                                ('stores.buttons.seeMore' | translateSafe) }}
                            </span>
                        </button>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="col-12 col-lg-6 col-xl-6">
            <div class="store-map">
                <app-mapbox
                    *ngIf="(storesService.stores$ | async) as stores else loadingMap"
                    [featureCollection]="stores | byRegion:activeRegions | toHtmlPopupProp:('stores.link.goToStore' | translateSafe): storesImage?.src | toGeoJson"
                    (ctaClick)="onCtaClick($event)"
                ></app-mapbox>
            </div>
        </div>
    </div>
</section>

<ng-template #emptyList> {{ 'stores.labels.noResults' | translateSafe }} </ng-template>

<ng-template #loadingMap>
    <div class="loading-wrapper">
        <app-loading-dots></app-loading-dots>
    </div>
</ng-template>
